<!-- RESERVA POR HORAS -->
@if (activeSection === 'reservation') {
  <mat-card appearance="outlined" class="booking-card" (click)="activate('reservation')">
    <mat-card-content>
      <h2>{{'offterlocker.title'|traduccion}}</h2>
      <form class="text-center">
        <!-- POR FECHAS -->
        @if (reservationMode === 'range') {
          <div class="section-block">
            <div>
                  <div class="inline-field">
                    <div class="dp-hidden position-absolute">
                      <div class="input-group">
                        <input name="datepicker" class="form-control d-none" ngbDatepicker
                          #datepicker="ngbDatepicker" [autoClose]="'outside'"
                          (dateSelect)="onDateSelection($event, datepicker)" [displayMonths]="1"
                          [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate" [minDate]="minDate"
                          [maxDate]="maxDate" tabindex="-1" />
                          <ng-template #t let-date let-focused="focused">
                            <span class="custom-day" [class.disabled]="isMinDate(date) || isMaxDate(date)"
                              [class.focused]="focused" [class.range]="isRange(date)"
                              [class.faded]="isHovered(date) || isInside(date)"
                              (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                              {{ date.day }}
                            </span>
                          </ng-template>
                        </div>
                      </div>
                      <div class="form-inline date-group">
                        <div class="form-group input-group-lg datepickut-wapper m-auto"
                          (click)="modeSelect && datepicker.toggle()">
                          <input #dpFromDate class="form-control input-date" placeholder="dd-mm-yyyy"
                            name="dpFromDate" [value]="formatDate(fromDate)"
                            (input)="fromDate = validateInput(fromDate, dpFromDate.value)" />
                          </div>
                          <div class="form-group input-group-lg datepickut-wapper m-auto"
                            (click)="modeSelect && datepicker.toggle()">
                            <input #dpToDate class="form-control input-date" placeholder="dd-mm-yyyy"
                              name="dpToDate" [value]="formatDate(toDate)"
                              (input)="toDate = validateInput(toDate, dpToDate.value)" />
                            </div>
                          </div>
                        </div>
                        <div class="inline-field">
                          @if (hasTime) {
                            <div class="form-inline date-group">
                              <div class="form-group input-group-lg datepickut-wapper m-auto">
                                <select (change)="onChangeFromTime($event)" class="form-select" name="dpFromTime">
                                  @for (item of fromTimeOptions; track item) {
                                    <option [value]="item">
                                      {{ item }}
                                    </option>
                                  }
                                </select>
                              </div>
                              <div class="form-group input-group-lg datepickut-wapper m-auto">
                                <select (change)="onChangeToTime($event)" class="form-select" name="dpToTime">
                                  @for (item of toTimeOptions; track item) {
                                    <option [value]="item">
                                      {{ item }}
                                    </option>
                                  }
                                </select>
                              </div>
                            </div>
                          }
                          @if (!modeSelect) {
                            <div class="m-0 p-0 align-self-center">
                              <div class="c-button">
                                <button type="button" (click)="less()" [disabled]="totalPeriod <= totalPeriodInitial"
                                  class="btn btn-primary btn-just-icon"><i
                                class="nc-icon nc-simple-delete"></i></button>
                                <span></span>
                                <button type="button" (click)="plus()" [disabled]="totalPeriod >= maxPeriod"
                                  class="btn btn-primary btn-just-icon">
                                  <i class="nc-icon nc-simple-add"></i>
                                </button>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  <!-- POR DURACIÓN -->
                  @if (reservationMode === 'duration') {
                    <div class="section-block">
                      <div class="duration-box">
                        <div class="duration-header">
                          <span>{{'offterlocker.init'|traduccion}}</span>
                          <strong>{{ today | date:'d MMM y' }}</strong>
                        </div>
                        <div class="duration-controls">
                          <button type="button" mat-mini-fab color="warn" (click)="decreaseDays(); activate('reservation')">
                            <mat-icon>remove</mat-icon>
                          </button>
                          <div class="duration-value">
                            <div class="big">{{ durationDays }}</div>
                            <div class="small">{{ durationDays === 1 ? 'día' : 'días' }}</div>
                          </div>
                          <button type="button" mat-mini-fab color="warn" (click)="increaseDays(); activate('reservation')">
                            <mat-icon>add</mat-icon>
                          </button>
                        </div>
                        <div class="duration-footer">
                          <span>{{'offterlocker.automaticEnd'|traduccion}}</span>
                          <strong>{{ computedEndDate | date:'d MMM y' }}</strong>
                        </div>
                      </div>
                    </div>
                  }
                </form>
                @if (showDetail) {
                  <div class="summary-box">
                    <div class="summary-row">
                      <span>{{'offterlocker.duration'|traduccion}}</span>
                      <strong class="duration">{{ durationLabel }}</strong>
                    </div>
                    <div class="summary-row">
                      <span>{{'offterlocker.total'|traduccion}}</span>
                      <strong class="price">{{minPrice | currency}}</strong>
                    </div>
                    <div class="summary-row">
                      <span>{{'offterlocker.from'|traduccion}}</span>
                      <strong>{{ fromDateTimeLabel }}</strong>
                    </div>
                    <div class="summary-row">
                      <span>{{'offterlocker.to'|traduccion}}</span>
                      <strong>{{ toDateTimeLabel }}</strong>
                    </div>
                  </div>
                }
              </mat-card-content>
            </mat-card>
          }

          <!-- SUSCRIPCIÓN -->
          @if (activeSection === 'subscription') {
            <mat-card appearance="outlined" class="booking-card" (click)="activate('subscription')">
              <mat-card-content>
                <h2>{{'reserve.subscription'|traduccion}}</h2>
                <p class="subtitle">{{'reserve.recurringPlans'|traduccion}}</p>
                @for (subscription of subscriptions; track subscription) {
                  <mat-radio-group class="subscription-group" [(ngModel)]="selectedPlan" (click)="onClickSubscription(subscription)">
                    <div class="plan-option" [class.selected]="selectedPlan === 'monthly'">
                      <mat-radio-button value="monthly">
                        {{subscription.period}} {{subscription.unit|traduccion}}
                      </mat-radio-button>
                      <strong>{{subscription.amount|currency}}</strong>
                    </div>
                  </mat-radio-group>
                }
                <div class="subscription-info">
                  <div class="info-row ok">
                    <mat-icon>check_circle</mat-icon>
                    <span>{{'offterlocker.init'|traduccion}}: <strong>{{'reserve.today'|traduccion}}</strong></span>
                  </div>
                  <div class="info-row ok light">
                    <mat-icon>done</mat-icon>
                    <span>{{'offterlocker.removeAutomatically'|traduccion}}</span>
                  </div>
                </div>
                <div class="summary-box">
                  <div class="summary-row">
                    <span>{{'offterlocker.nextPayment'|traduccion}}</span>
                    <strong>{{ nextChargeLabel }}</strong>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          }
